module.exports = __webpack_public_path__ + "img/draw-subject.c3819005.png";